module.exports = __webpack_public_path__ + "img/ic_publicity3.a676ee5e.jpeg";